import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Grid, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { CityUserDetail, WebsiteRealTimeCountSummary } from '../dataObjects/WebsiteRealTimeCountSummary';

interface realTimeSummaryProps {
    summary?: WebsiteRealTimeCountSummary;
}

const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#fafafa',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const WebsiteRealTimeSummary = (props: realTimeSummaryProps) => {

    return (
    <>
        <Stack direction="row" spacing={1} marginRight={2}>
            <Card variant="outlined" sx={{ height: '100%', flexGrow: 1, border: 'none'}}>
                <CardContent>
                    <Typography color={'blue'} variant="subtitle2" gutterBottom>
                        ACTIVE USERS IN LAST 30 MINUTES
                    </Typography>
                    <Typography variant="h4" component="p">
                        {props.summary?.totalUsers}
                    </Typography>
                </CardContent>
            </Card>
        </Stack>
        <Grid item xs={10}>
            {
                props.summary?.details && props.summary?.details.length > 0 &&
                <TableContainer>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#FFFFFF'}}>
                                <TableCell><Typography variant='caption' fontWeight={550}>CITY</Typography></TableCell>
                                <TableCell sx={{ textAlign:"right!important" }} ><Typography variant='caption' fontWeight={550}>ACTIVE USERS</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.summary?.details.map((city: CityUserDetail, index) =>
                                city.city &&
                                <StyledTableRow key={index}>
                                    <TableCell>
                                            <Typography variant="body2">{city.city}</Typography>
                                        </TableCell>
                                    <TableCell>
                                            <Typography variant="body2" align="right">{city.activeUsers}</Typography>
                                        </TableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                     </Table>
                </TableContainer>
            }
        </Grid>
    </>
    );
}

export default WebsiteRealTimeSummary 